<template>
  <main class="home">
    <TheHeader />
    <HomeBanner />
    <section class="home__match" v-if="match !== null && match !== undefined">
      <h2>Próximo jogo</h2>
      <div class="home__match__wrapper">
        <section class="home__match__team">
          <figure>
            <img src="@/assets/team/sport.png" alt />
          </figure>
          <p>Sport</p>
        </section>
        <span class="home__match__team home__match__team--versus"></span>
        <section class="home__match__team">
          <figure>
            <img :src="match.image" alt />
          </figure>
          <p>{{ match.title }}</p>
        </section>
      </div>
    </section>

    <MainSection />

    <section class="home__card">
      <img
        src="@/assets/background-todos.png"
        alt
        class="img-background desktop"
      />
      <img
        src="@/assets/background-todos-mobile.jpg"
        alt
        class="img-background mobile"
      />
      <div class="home__card__wrapper">
        <div class="limit-grid">
          <div class="home__card__content">
            <h3>Cartão de TODOS Sport Club do Recife</h3>
            <p>
              Com o Cartão de TODOS, sua família passa por consultas, dentistas
              e faz exames na hora que precisa, pelo preço que pode pagar. E
              você ainda tem acesso a descontos em educação e lazer.
            </p>
            <div class="home__card__content__price">
              <fieldset class="home__card__content__price__item">
                <legend>
                  Mensalidade
                  <span>de apenas</span>
                </legend>
                <div class="home__card__content__price__item__wrapper">
                  <h4>
                    R$
                    <span>{{ cdtPrices.valor.split(",")[0] }}</span
                    >,{{ cdtPrices.valor.split(",")[1] }}
                  </h4>
                  <p>para toda a família</p>
                </div>
              </fieldset>
              <fieldset class="home__card__content__price__item">
                <legend>Consultas</legend>
                <div class="home__card__content__price__item__wrapper">
                  <div class="home__card__content__price__item__half">
                    <p>
                      Clínico
                      <span>geral</span>
                    </p>
                    <h4>
                      R$
                      <span>{{ cdtPrices.clinico_geral }}</span>
                    </h4>
                  </div>
                  <div class="home__card__content__price__item__half">
                    <p>Demais especialidades</p>
                    <h4>
                      R$
                      <span>{{ cdtPrices.demais }}</span>
                    </h4>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="disclaimer">
              Anuidade de R$ {{ cdtPrices.anuidadeTimes }} reais, pode ser
              parcelada em até 12 vezes no cartão. E você ganha sua carteirinha
              personalizada, saúde, educação e lazer!
            </div>
            <a
              href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=27"
              target="_blank"
              class="home__card__request"
              @click="handleCTAClick"
              >SOLICITAR MEU CARTÃO</a
            >
          </div>
        </div>
      </div>
    </section>

    <section class="home__partners">
      <div class="limit-grid">
        <h2>APROVEITE A NOSSA REDE COM MAIS DE 12.000 PARCEIROS.</h2>
        <SearchBar />
      </div>
    </section>

    <section class="home__faq">
      <div class="limit-grid">
        <div class="home__faq__wrapper">
          <h2>
            Perguntas
            <span>Frequentes</span>
          </h2>
          <div class="accordion">
            <AccordionItem
              :title="accordion.title"
              :text="accordion.text"
              v-for="(accordion, index) in accordions"
              :key="index"
            />
          </div>
        </div>
        <!-- <section class="home__video">
          <h2>lorem ipsum</h2>

          <div
            :class="[
              'home__video__container',
              { 'home__video__container--active': playVideo },
            ]"
            @click="play()"
          >
            <img src="@/assets/video.jpg" alt />
            <div class="home__video__frame">
              <iframe
                width="100%"
                height="100%"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="home__video__mask">
              <img src="@/assets/play.svg" alt />
            </div>
          </div>
        </section>-->

        <!-- <div class="home__faq__card">
          <div class="home__faq__card__wrapper">
            <h4>Você já é filiado do Cartão de TODOS?</h4>
            <img src="@/assets/cartao-bar.png" alt class="hidden-xs" />
            <img src="@/assets/cartao-bar@2x.png" alt class="show-xs" />
            <div class="home__faq__card__content">
              <p>
                Troque agora mesmo para o Cartão de TODOS sport por apenas
                R$ 20.
              </p>
              <form>
                <input type="text" name placeholder="Número de matrícula" />
                <button>Enviar</button>
              </form>
            </div>
          </div>
        </div>-->
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { makeNextGameUseCase } from "../team-game/main/helper/make-next-game-use-case";
import { handleCTAClick } from "@/services/gtm";

export default {
  title() {
    return `Cartão de TODOS Sport`;
  },
  data() {
    return {
      match: null,
      playVideo: false,
      accordions: [
        {
          title: "Como pedir meu <strong>Cartão de TODOS Sport</strong>?",
          text:
            'Pelo Site: entre em "Solicite seu cartão" preencha o campo "CEP" e siga os processos e passos; <br>Pelo Telefone: 0800 729 2076; <br>ou Pessoalmente: nas Franquias do Cartão de TODOS mais próxima da sua residência.',
        },
        {
          title: "Quanto custa o <strong>Cartão de TODOS Sport</strong>? ",
          text:
            "O valor da adesão é de R${{valor_mensalidade}}, a mensalidade tem o valor de R${{valor_mensalidade}} e a anuidade é de R${{valor_anuidadetimes}} podendo ser dividida em até 12 vezes de R${{valor_anuidadetimes_12X}}.",
        },
        {
          title:
            "Já tenho o Cartão de TODOS, como eu faço para transferir para o <strong>Cartão de TODOS Sport</strong>?",
          text:
            "Vá até a franquia do Cartão de TODOS mais próxima de sua residência e solicite o upgrade para o seu plano. O filiado pagará pelo upgrade o valor da anuidade e a nova carteirinha. A anuidade possui o valor de R${{valor_anuidadetimes}}, podendo ser dividida em até 12 vezes de R${{valor_anuidadetimes_12X}} e a carteirinha tem o valor sugerido de R$10.",
        },
        {
          title: "Como o <strong>Cartão de TODOS Sport</strong> funciona?",
          text:
            "O Cartão de TODOS é uma empresa que trabalha no ramo de cartões de desconto, oferecendo a intermediação de descontos entre pessoas físicas (aderentes) e pessoas jurídicas (empresas parceiras). Ao aderir ao Cartão de TODOS e realizar o pagamento de suas mensalidades, o cliente passa a ter benefícios de descontos em uma vasta rede de empresas parceiras nas áreas de saúde, educação e lazer, espalhadas em todo o brasil. Um ótimo exemplo destes benefícios são os custos de consultas nas clínicas parceiras - R$ {{valor_clinicogeral}} clínico geral e R$ {{valor_demaisespecialidades}} demais áreas, além de descontos especiais em procedimentos, tratamentos odontológicos completos e exames. O cliente paga uma taxa de emissão do cartão no valor de R$ {{valor_mensalidade}} (paga no ato do contrato) e as mensalidades são no valor de R$ {{valor_mensalidade}}. A anuidade é paga pelo cliente em até 12 parcelas de R$ {{valor_anuidadetimes_12X}}. Você pode colocar como dependentes cônjuge e filhos até 21 anos.",
        },
      ],
    };
  },
  components: {
    HomeBanner: () => import("@/components/HomeBanner.vue"),
    SearchBar: () => import("@/components/SearchBar.vue"),
    AccordionItem: () => import("@/components/AccordionItem.vue"),
    MainSection: () => import("@/components/Section/index.vue"),
  },
  methods: {
    handleCTAClick,
    play() {
      let url =
        "https://www.youtube.com/embed/jpvhW0owgSw?rel=0&autoplay=1&showinfo=0&controls=0";
      let iframe = document.querySelector("iframe");
      this.playVideo = !this.playVideo;

      if (this.playVideo) {
        iframe.setAttribute("src", url);
      } else {
        iframe.removeAttribute("src");
      }
    },
    nextGame(matches) {
      let currentDate = new Date();
      for (var i = 0; i < matches.length; i++) {
        let matchDate = matches[i].match_date.split("/");
        let convertDate = new Date(
          +matchDate[2],
          matchDate[1] - 1,
          +matchDate[0],
          23,
          59
        );
        if (currentDate <= convertDate) {
          return {
            title: matches[i].match_tile,
            image: matches[i].match_image,
          };
        }
      }
    },
    async getMatch() {
      const nextGame = makeNextGameUseCase();
      this.match = await nextGame.handle({ teamId: 123 });
    },
    replacePlaceholders(text, values) {
      return text
        .replace("{{valor_mensalidade}}", `R$ ${values.valor}`)
        .replace("{{valor_clinicogeral}}", `R$ ${values.clinico_geral}`)
        .replace("{{valor_demaisespecialidades}}", `R$ ${values.demais}`);
    },
  },
  created() {
    this.getMatch();
  },
  computed: {
    ...mapGetters(["cdtPrices"]),
  },
};
</script>

<style lang="scss">
.home {
  background-color: #c5c7c9;
  &__match {
    position: relative;
    z-index: 80;
    padding: 17px 0px 7px;
    width: 250px;
    border-radius: 20px;
    margin: 0 auto;
    margin-top: -70px;
    background: $color-white;
    font-family: "HelveticaNeue";
    h2 {
      font-size: 10px;
      line-height: 12px;
      font-weight: 100;
      color: $color-gray;
      text-align: center;
      margin-bottom: 2px;
    }
    &__wrapper {
      display: grid;
      grid-template-columns: auto min-content auto;
      text-align: center;
    }

    &__team {
      align-items: center;
      justify-content: center;
      display: inherit;
      color: $color-gray;
      figure {
        margin: initial;
        width: 100%;
        text-align: center;
        margin-bottom: 8px;
        img {
          max-height: 40px;
        }
      }
      &--versus {
        &::after {
          content: url("../assets/icons/versus.svg");
          font-size: 20px;
          font-weight: bold;
        }
      }

      p {
        font-family: "HelveticaNeue";
        font-size: 10px;
        font-weight: bold;
      }
    }
  }
  &__discount {
    padding: 90px 0;
    background: $color-lightgray;
    margin-top: -33px;
    @include media(">=tablet") {
      padding: 100px 0;
    }
    &__grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      text-align: center;
      grid-gap: 26px 10px;
      @include media(">=tablet") {
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 40px;
      }
      &__item {
        figure {
          height: 60px;
          margin: initial;
        }

        &__description {
          h2 {
            font-family: "Arvo", serif;
            color: $color-gray;
            font-size: 20px;
            margin-top: 10px;
            @include media("<=small") {
              font-size: 14px;
            }
          }

          p {
            color: $color-gray;
            margin: 7px auto 0;
            max-width: 225px;
            font-size: 13px;
            span {
              display: block;
            }
            @include media(">=tablet") {
              font-size: 14px;
            }
          }
        }
      }
    }

    &__more {
      margin-top: 19px;
      margin-bottom: 23px;
      text-align: center;
      @include media(">=small") {
        margin-top: 59px;
      }
      a {
        text-decoration: none;
        padding: 10px 38px;
        background: $color-black;
        color: $color-primary;
        font-weight: 700;
        border-radius: 31px;
        transition: 0.3s ease-in-out;
        font-size: 20px;
        font-family: "Arvo", serif;
        width: 100%;
        display: block;
        border: 2px solid $color-black;

        @include media(">=tablet") {
          display: initial;
          &:hover {
            background: $color-primary;
            color: $color-black;
            border: 2px solid $color-black;
          }
        }
      }
    }
  }

  &__card {
    position: relative;
    margin-bottom: -1px;
    @include media(">=tablet") {
      margin-bottom: initial;
      overflow: hidden;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 80px);
      background: $color-secondary;
      z-index: -1;
      @include media(">=tablet") {
        display: none;
      }
    }

    .img-background {
      width: 100%;
      max-width: 100%;
      margin-bottom: -4px;
      height: 367px;
      object-fit: cover;
      object-position: 100% 0;
      @include media(">=tablet") {
        min-height: 818px;
        height: initial;
        object-position: initial;
      }
    }

    &__wrapper {
      top: calc(50% + 40px);
      width: 100%;
      transform: translateY(-48%);
      @include media(">=tablet") {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    &__content {
      color: $color-white;
      @include media(">=small") {
        padding-bottom: 20vh;
        position: relative;
      }
      @include media(">=tablet") {
        max-width: 577px;
        padding-bottom: initial;
      }
      &::after {
        content: "";
        background: url("../assets/mockup-valores.png") no-repeat;
        background-size: 100% auto;
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: -140px;
        right: 0px;
        transform: translateY(630px);
        @include media(">=small") {
          transform: translateY(30vh);
          background-size: 80% auto;
          right: -30px;
        }
        @include media(">=tablet") {
          background-size: auto 75%;
          bottom: initial;
          top: 7%;
          transform: translateX(100%) translateY(0%);
        }
      }

      h3 {
        font-family: "Arvo", sans-serif;
        font-size: 17px;
        line-height: 20px;
        font-weight: 700;
        margin-bottom: 15px;
        margin-top: 70px;
        width: 183px;
        color: $color-lightgray;
        @include media(">=tablet") {
          font-size: 50px;
          line-height: 61px;
          width: initial;
          padding-bottom: 30px;
        }
      }

      p {
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: $color-lightgray;
        @include media("<=small") {
          font-size: 13px;
          line-height: 16px;
        }
      }

      a {
        display: block;
        font-family: "Arvo", serif;
        font-size: 22px;
        font-weight: 700;
        text-decoration: none;
        padding: 15px 20px;
        background: $color-black;
        color: $color-primary;
        border-radius: 31px;
        transition: 0.3s ease-in-out;
        transform: translateY(340px);
        text-align: center;
        border: 2px solid $color-black;
        @include media(">=small") {
          margin: 0px auto;
          transform: initial;
          transform: translateY(calc(20vh + 150px));
        }
        @include media(">=tablet") {
          display: inline-block;
          padding: 20px 45px;
          transform: initial;
          background: $color-black;
          color: $color-primary;
          font-size: 20px;
          &:hover {
            background: $color-primary;
            color: $color-black;
          }
        }
      }

      &__price {
        max-width: 544.34px;
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 30px;
        margin: 37px 0;
        align-items: flex-end;
        @include media(">=small") {
          margin: 37px auto;
          grid-template-columns: 241px auto;
        }
        @include media(">=tablet") {
          margin: 37px 0px;
        }
        &__item {
          padding: initial;
          border: 6px solid $color-primary;
          border-radius: 20px;
          background: RGBA(0, 0, 0, 0.33);
          z-index: 9;
          color: $color-white;
          height: 197px;
          margin: 0 auto;
          padding: 0 15px;
          @include media(">=small") {
            width: 100%;
            padding: initial;
          }
          &:first-child {
            height: 208px;
            h4 {
              font-size: 39px;
              margin-top: 9px;
              color: $color-lightgray;
              span {
                font-size: 76px;
                line-height: 94px;
              }
            }
            p {
              text-transform: uppercase;
              text-align: center;
              color: $color-lightgray;
            }
          }
          legend {
            text-align: center;
            padding: 0 26px;
            font-weight: 900;
            font-size: 20px;
            color: $color-lightgray;
            @include media("<=small") {
              font-size: 17px;
            }
            text-transform: uppercase;

            span {
              display: block;
            }
          }

          &__wrapper {
            margin: 0 22px;
            text-align: center;
          }
          &__half {
            display: flex;
            align-items: center;
            margin-top: 10px;
            h4 {
              margin-left: auto;
            }
            p {
              text-align: left;
            }
          }

          h4 {
            font-family: "Arvo", sans-serif;
            font-size: 27px;
            font-weight: 700;
            display: flex;
            align-items: center;
            color: $color-lightgray;
            span {
              font-size: 57px;
              line-height: 71px;
              font-weight: 700;
              display: initial;
            }
          }
          p {
            font-weight: 900;
            font-size: 14px;
            line-height: 17px;
            color: $color-lightgray;
            span {
              display: block;
            }
          }
        }
      }
    }

    &__request {
      position: relative;
      z-index: 95;
    }
  }

  &__partners {
    background: $color-lightgray;
    padding-top: 60px;
    @include media(">=tablet") {
      padding-top: 114px;
    }
    h2 {
      color: $color-black;
      font-family: "Arvo", sans-serif;
      font-size: 17px;
      font-weight: 700;
      text-align: center;
      max-width: 520px;
      margin: 0 auto;
      @include media(">=tablet") {
        font-size: 30px;
      }
      span {
        color: $color-white;
      }
    }
  }

  &__faq {
    background: url("../assets/background-faq-mobile.jpg") $color-secondary top
      center no-repeat;
    background-size: 100% auto;
    position: relative;
    padding: 39px 0 79px;
    @include media(">=tablet") {
      background: url("../assets/background-faq.jpg") $color-secondary no-repeat
        top center;
      background-size: cover;
      padding: 64px 0 80px;
      overflow-x: hidden;
      min-height: 768px;
      background-size: 100% auto;
    }
    // &::after {
    //   content: "";
    //   width: 100%;
    //   height: 100%;
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   background: RGBA(0, 0, 0, 0.6);
    //   z-index: 1;
    // }
    &__wrapper {
      position: relative;
      z-index: 2;
      display: grid;
      grid-template-columns: 1fr;
      @include media(">=tablet") {
        grid-template-columns: 40% 1fr;
      }
      h2 {
        color: $color-primary;
        font-size: 17px;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        text-transform: uppercase;
        margin-bottom: 39px;
        text-align: center;
        @include media(">=tablet") {
          max-width: 250px;
          font-size: 40px;
          margin-bottom: initial;
          text-align: left;
        }
        span {
          font-family: "Arvo", sans-serif;
          font-weight: 700;
        }
      }
    }
    &__card {
      position: relative;
      z-index: 2;
      margin-top: 60px;
      &__wrapper {
        background: url("../assets/background-cartao.jpg") $color-white
          no-repeat left top;
        display: grid;
        grid-template-columns: 1fr;
        align-items: center;
        position: relative;
        padding: 0 18px 14px;
        text-align: center;
        @include media(">=tablet") {
          background: url("../assets/background-cartao.jpg") $color-white
            no-repeat left center;
          height: 200px;
          text-align: initial;
          padding: 0 60px;
          grid-template-columns: 228px 282.61px 1fr;
        }
        &::after {
          content: "";
          width: calc(100% + 18px);
          height: 100%;
          background: url("../assets/arrow-out-top.svg") no-repeat left center;
          background-size: contain;
          z-index: 1;
          position: absolute;
          top: -40px;
          left: -9px;
          @include media(">=tablet") {
            height: calc(100% + 18px);
            width: 100%;
            background: url("../assets/arrow-out.svg") no-repeat left center;
            top: -5px;
            left: 290px;
          }
        }
        &::before {
          content: "";
          width: 100%;
          height: calc(100% - 160px);
          background: $color-white;
          z-index: 2;
          position: absolute;
          bottom: 0;
          right: 0;
          @include media(">=tablet") {
            width: calc(100% - 370px);
            height: 100%;
          }
        }
      }

      h4,
      img {
        margin-top: -28px;
      }

      h4,
      img,
      &__content {
        position: relative;
        z-index: 6;
      }
      h4 {
        font-family: "Arvo", sans-serif;
        font-size: 24px;
        line-height: 30px;
        font-weight: 700;
        color: $color-white;
        max-width: 228px;
        margin: 28px auto 0px;
        @include media(">=tablet") {
          max-width: initial;
          margin: initial;
        }
      }
      img {
        transform: translateY(28px) translateX(14%);
        max-width: 100%;
        @include media(">=tablet") {
          transform: translateY(28px);
          margin-left: 50px;
        }
        &.show-xs {
          display: block;
          @include media(">=tablet") {
            display: none;
          }
        }
        &.hidden-xs {
          display: none;
          @include media(">=tablet") {
            display: block;
          }
        }
      }
      &__content {
        p {
          font-size: 14px;
          line-height: 17px;
          max-width: 413px;
          margin-bottom: 18px;
          @include media(">=tablet") {
            font-size: 20px;
            line-height: 24px;
            margin-bottom: initial;
          }
        }
        form {
          position: relative;
          margin-top: 11px;
          input {
            width: 100%;
            height: 51px;
            font-size: 14px;
            border: 1px solid $color-black;
            border-radius: 10px;
            padding: 0 16px;
            outline: none;
            @include media(">=tablet") {
              width: calc(100% - 50px);
            }
          }
          button {
            font-family: "HelveticaNeue";
            width: 82px;
            height: 53px;
            background: $color-black;
            color: $color-white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13;
            border: 0px none;
            border-radius: 10px;
            position: absolute;
            right: 0;
            top: 0;
            outline: none;
            cursor: pointer;
            transition: 0.3s ease-in-out;
            &:hover {
              background: $color-primary;
              color: $color-black;
            }
          }
        }
      }
    }
  }

  &__video {
    z-index: 99;
    position: relative;
    padding-bottom: 55px;
    h2 {
      text-align: center;
      font-family: "Arvo", sans-serif;
      font-weight: 700;
      font-size: 17px;
      color: $color-primary;
      text-transform: uppercase;
      margin: 0;
      padding-bottom: 55px;
      padding-top: 20px;
      @include media(">=tablet") {
        font-size: 30px;
        padding-top: 80px;
      }

      span {
        display: block;
        font-weight: 700;
        color: $color-primary;
      }
    }

    &__mask {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      img {
        transition: 0.3s ease-in-out;
        max-height: 50%;
        @include media(">=tablet") {
          max-height: initial;
        }
      }
    }

    &__frame {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }

    &__container {
      position: relative;
      width: 100%;
      cursor: pointer;
      img {
        max-width: 100%;
        height: 455px;
        object-fit: cover;
        @include media(">=tablet") {
          height: initial;
        }
      }
      @include media(">=tablet") {
        &:hover {
          .home__video__mask {
            img {
              transform: scale(1.2);
            }
          }
        }
      }
      &--active {
        .home__video__frame {
          z-index: 20;
        }
      }
    }
  }
}

.disclaimer {
  color: #fff;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
  margin-bottom: 28px;
}
</style>
